'use strict';

angular.module('directives.IAMContact', ['helpers.mail'])

.directive('iamContact', ['$window', function ($window) {
    return {
        transclude: true,
        scope: {
            subject: '@',
            iamEmailAddress: '=?',
            iamPhone: '=?',
            iamMailTo: '=?'
        },
        controller: ['$scope', 'Mailto', function($scope, Mailto) {
            $scope.iamEmailAddress = $scope.iamEmailAddress || 'iam@investpsp.ca';
            $scope.iamPhone = $scope.iamPhone || 'x3621 | +1 514.218.3621';

            var optionsIamMailTo = { subject: $scope.subject };
            $scope.iamMailTo = Mailto.url($scope.iamEmailAddress, optionsIamMailTo);
        }],
        template: '<span><i class="fa fa-envelope-o"></i>&nbsp;<a ng-click="mailTo()" target="_top">{{ iamEmailAddress }}</a>' +
                  '</span><span>&nbsp;&nbsp;<i class="fa fa-phone"></i>&nbsp;{{ iamPhone }}</span>',
        link: function (scope, el, attrs, ctrl, transcludeFn) {
            var transcludedContent = transcludeFn();

            if (transcludedContent.length > 0) {
                transcludeFn(scope, function(clonedTranscludedContent) {
                    el.replaceWith(clonedTranscludedContent);
                });
            }

            scope.mailTo = function () {
                $window.top.location.href = scope.iamMailTo;
            }
        }
    }
}]);
